import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMobile } from 'store/user';
import useProfile from './useProfile';

export const useIsMobile = () => {
  const dispatch = useDispatch();
  const {isMobile} = useProfile();
  const handleResizeRef = useRef();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    handleResizeRef.current = () => {
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile !== mobile) {
        dispatch(setIsMobile(mobile));
      }
    };

    handleResizeRef.current();

    window.addEventListener('resize', handleResizeRef.current);

    return () => {
      window.removeEventListener('resize', handleResizeRef.current);
    };
  }, [isMobile, dispatch]);

  return isMobile;
};
